// Pure geographic helpers — unit-testable in Phase 5.
import type { BBox } from '@/types/domain';

const EARTH_RADIUS_KM = 6371;
const toRad = (deg: number): number => (deg * Math.PI) / 180;

/** Great-circle distance between two [lng, lat] points in km. */
export function haversineKm(a: [number, number], b: [number, number]): number {
  const dLat = toRad(b[1] - a[1]);
  const dLng = toRad(b[0] - a[0]);
  const lat1 = toRad(a[1]);
  const lat2 = toRad(b[1]);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
}

export function isInBBox(point: [number, number], bbox: BBox): boolean {
  return (
    point[0] >= bbox.minLng &&
    point[0] <= bbox.maxLng &&
    point[1] >= bbox.minLat &&
    point[1] <= bbox.maxLat
  );
}

/** Viewport center from a bounding box. */
export function bboxCenter(bbox: BBox): [number, number] {
  return [(bbox.minLng + bbox.maxLng) / 2, (bbox.minLat + bbox.maxLat) / 2];
}
